module.exports = __webpack_public_path__ + "img/villarossa.c540bde3.svg";